export default __webpack_public_path__ + "static/media/ID_MIKE.91bfad08.jpg";